import styled, { css } from 'styled-components';

interface Props {
  errorMessage?: string;
  disabled?: boolean;
  width: string;
  withButtonAlternative?: boolean;
}

export const IconAlert = styled.img`
  padding: 0;
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

export const InputStyled = styled.input<Props>`
  height: 40px;
  width: ${props => (props.width ? props.width : '366px')};
  padding: 10px;
  margin-top: 8px;
  font-size: 14px;
  font-family: 'Inter';
  background-color: ${props => (!props.disabled ? '#FFFFFF' : '#d8d8d8')};
  color: #000000;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${props => (!props.disabled ? '#FFFFFF' : '#d8d8d8')};
    font-style: italic;
    color: #666666;
    font-size: 14px;
    font-family: 'Inter';
  }

  border: 1px solid #666666;
  border-radius: 8px;

  ${props =>
    props.errorMessage &&
    css`
      border-image: none;
      border: 1px solid red;
    `}

  &:disabled {
    opacity: 1;
  }

  &:read-only {
    cursor: not-allowed;
    background-color: #d8d8d8;
    color: #000000;
    border: 1px solid #666666;
    border-radius: 8px;
  }

  &:focus,
  &:hover {
    outline: none;
    border: ${props =>
      !props.errorMessage ? '1px solid #0669de' : '1px solid red'};
  }

  /* FIX: autofill do Chrome */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-internal-autofill-selected,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 50px
      ${props => (!props.disabled ? '#FFFFFF' : '#d8d8d8')} inset !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const DisplayIntervention = styled.div`
  display: block;
  text-align: center;
`;

export const InputPasswordContainer = styled.div`
  position: relative;
`;

export const ErrorMessage = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-top: 5px !important;
  color: red;
  font-size: 14px;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  max-width: 366px;

  @media (max-width: 650px) {
    max-width: 100%;
  }
`;

export const DisableMessage = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-top: 12px !important;
  color: #666666;
  font-size: 14px;
  width: 366px;
  display: flex;
  align-items: center;
  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const EyeIcon = styled.span`
  width: 20px;
  top: 16px;
  right: 15px;
  position: absolute;

  > button {
    height: 24px;
    border: none;
    background: none;
    padding: 0;
  }
`;

export const InputBox = styled.div`
  margin-top: 10px;
  display: flex;
  width: 366px;
  align-items: center;

  @media (max-width: 650px) {
    width: 100%;
  }

  > input {
    max-width: 50%;
    margin-right: 10px;
    margin-top: 0;
    @media (max-width: 650px) {
      width: 100%;
    }
  }

  > button {
    width: 50%;
    height: 40px;
    @media (max-width: 650px) {
      width: 100%;
    }
  }
`;

export const InputContainer = styled.div`
  > button {
    margin-top: 32px;
  }
`;
